import { useLoading } from '#GameFrontend/contexts/LoadingContext';
import { socket } from '#GameFrontend/services/socket';
import Step1 from '#GameFrontend/unauthorized/components/register/Step1';
import Step2 from '#GameFrontend/unauthorized/components/register/Step2';
import Step3 from '#GameFrontend/unauthorized/components/register/Step3';
import Step4 from '#GameFrontend/unauthorized/components/register/Step4';
import StepsContainer from '#GameFrontend/unauthorized/components/register/StepsContainer';
import { defaultStarter, Starter } from '#GameFrontend/unauthorized/types/Starter';
import { defaultStarterForm, StarterFormProps } from '#GameFrontend/unauthorized/types/StarterForm';
import React, { useEffect, useState } from 'react';
import './register.css';

const Register: React.FC = () => {
	const { setIsLoading } = useLoading();
	const [currentStep, setCurrentStep] = useState(1);
	const [bloodlines, setBloodlines] = useState<Starter[]>([defaultStarter]);
	const [index, setIndex] = useState(0);
	const path = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_PORT !== '80' && process.env.REACT_APP_PORT !== '443' ? `:${process.env.REACT_APP_PORT}` : ''}/image/horses/starter/`;
	const [form, setForm] = useState<StarterFormProps>(defaultStarterForm);

	const handleNext = () => {
		const newIndex = (index + 1) % bloodlines.length;
		setIndex(newIndex);
		setForm((prevData) => ({ ...prevData, id: bloodlines[newIndex].id }));
	};

	const handlePrevious = () => {
		const newIndex = (index - 1 + bloodlines.length) % bloodlines.length;
		setIndex(newIndex);
		setForm((prevData) => ({ ...prevData, id: bloodlines[newIndex].id }));
	};

	const handleNextStep = () => {
		setCurrentStep(currentStep + 1);
	};

	useEffect(() => {
		setIsLoading(true);
	}, [bloodlines, index]);

	useEffect(() => {
		setIsLoading(true);
		socket.on('Starter:All', (data) => {
			if (data.success) {
				const sortedBloodlines = data.data.sort((a: any, b: any) => b.id - a.id);
				setBloodlines(() => [...sortedBloodlines]);
				// Set initial bloodline id
				setForm((prevData) => ({ ...prevData, id: sortedBloodlines[0].id }));
			}
		});
		socket.timeout(5000).emit('Starter:All', {});
	}, []);

	return (
		<div className="container mx-auto px-4 flex flex-col flex-grow 2xl:max-w-[80%]">
			{/* Background Image for Mobile */}
			<div className="absolute top-0 left-0 right-0 z-0 lg:hidden mobile-background"></div>

			<div className="flex-grow grid grid-cols-1 lg:grid-cols-[20%_1fr_30%] xl:grid-cols-[25%_1fr_25%] lg:gap-8 ">
				<StepsContainer currentStep={currentStep} stepHandler={setCurrentStep} />
				{currentStep === 1 && (
					<Step1
						key={currentStep}
						bloodlines={bloodlines}
						index={index}
						handleNext={handleNext}
						handlePrevious={handlePrevious}
						nextStep={handleNextStep}
					/>
				)}
				{currentStep === 2 && (
					<Step2
						key={currentStep}
						bloodline={bloodlines[index]}
						nextStep={handleNextStep}
						formData={form}
						setFormData={setForm}
					/>
				)}
				{currentStep === 3 && (
					<Step3
						key={currentStep}
						bloodline={bloodlines[index]}
						nextStep={handleNextStep}
						formData={form}
						setFormData={setForm}
					/>
				)}
				{currentStep === 4 && <Step4 key={currentStep} bloodline={bloodlines[index]} formData={form} />}
			</div>
		</div>
	);
};

export default Register;
